import React from 'react'

import { NotificationModal } from '@masfront/common-b2c'
import { Formik } from 'formik'

import { Card, Box, Button, CircularProgress } from '@material-ui/core'

import AgentInfo from './components/AgentInfo'
import ClientInfo from './components/ClientInfo'
import { SalesLeadSchema, salesLeadsValues } from './LeadsPage.schema'
import useLeadsPage from './useLeadsPage'

function LeadsForm() {
  const {
    hasMsError,
    setHasMsError,
    hasMsSuccess,
    onResetData,
    isLoading,
    onSubmit,
    brandOptions,
    productOptions,
    segmentOptions,
    hoursOptions,
    shouldShowHours,
  } = useLeadsPage()
  return (
    <Box display="flex" justifyContent="center" p={10}>
      <Box component={Card} width="80%" p={6}>
        <AgentInfo
          brandOptions={brandOptions}
          productOptions={productOptions}
          segmentOptions={segmentOptions}
        />
        <ClientInfo hoursOptions={hoursOptions} shouldShowHours={shouldShowHours} />
        <Box>
          <NotificationModal
            open={hasMsError}
            type="error"
            actions={[]}
            description="Ha sucedido un error al intentar guardar los datos del cliente, por favor inténtalo de nuevo"
            title="Error"
            onClose={() => setHasMsError(false)}
          />
          <NotificationModal
            open={hasMsSuccess}
            type="success"
            actions={[]}
            description="Registro insertado correctamente"
            onClose={onResetData}
          />
          <Box mt={6}>
            {!isLoading ? (
              <Button variant="outlined" color="secondary" onClick={onSubmit}>
                Confirmar
              </Button>
            ) : (
              <CircularProgress size={50} />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default function LeadsPage() {
  return (
    <Formik
      validationSchema={SalesLeadSchema}
      initialValues={salesLeadsValues}
      onSubmit={() => undefined}
      enableReinitialize
      render={(props) => (
        <form onSubmit={props.handleSubmit}>
          <LeadsForm />
        </form>
      )}
    />
  )
}
